var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }

  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;

    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


// ---------------------------------------------------------------------------
// Preloader
// ---------------------------------------------------------------------------

// if ($("#preloader").length > 0) {
//   $(window).on("load", function () {
//     $("#preloader")
//       .delay(1000)
//       .fadeOut(1000, function () {
//         if ($(".preloader-overflow").length > 0) {
//           $("body").removeClass("preloader-overflow");
//         }
//       });
//   });
// }

document.addEventListener("DOMContentLoaded", () => {
  const pre = document.getElementById("preloader");

  if (!pre) return;

  pre.classList.add("fade-out");

  setTimeout(() => {
    pre.remove();
    document.body.classList.remove("preloader-overflow");
  }, 300);
});


// ---------------------------------------------------------------------------
// Product Slider
// ---------------------------------------------------------------------------

$(document).ready(function () {
  var Dwin = $(this);

  if (Dwin.width() > 1024) {
    slickVeritcal();
  } else {
    slickHorizontal();
  }
});

$(window).on("resize", function () {
  var win = $(this);

  if (win.width() > 1024) {
    slickVeritcal();
  } else {
    slickHorizontal();
  }
});

function slickVeritcal() {
  if ($(".media-slick-slider  .thumbnail-list li").length > 6) {
    $(".thumbnail-list").not(".slick-initialized").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      vertical: true,
      focusOnSelect: true,
      verticalSwiping: true,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            vertical: false,
          },
        },
        {
          breakpoint: 1541,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
}

function slickHorizontal() {
  if ($(".media-slick-slider  .thumbnail-list li").length > 5) {
    $(".thumbnail-list").slick("unslick");
  }
}


// ---------------------------------------------------------------------------
// Sticky Bar
// ---------------------------------------------------------------------------

$(window).scroll(function () {
  if ($(window).width() > "1024") {
    if ($(window).scrollTop() >= 700) {
      $(".sticky-bar").addClass("active");
    } else {
      $(".sticky-bar").removeClass("active");
    }
  }
});

$(window).scroll(function () {
  if ($(window).width() < "1024") {
    if ($(window).scrollTop() >= 900) {
      $(".sticky-bar").addClass("active");
    } else {
      $(".sticky-bar").removeClass("active");
    }
  }
});


// ---------------------------------------------------------------------------
// Recently Viewed
// ---------------------------------------------------------------------------

$(document).ready(function () {
  $("#recently").click(function () {
    $("#recently-viewed-products").slideToggle(500);
  });
});


// ---------------------------------------------------------------------------
// Ajaxinate
// ---------------------------------------------------------------------------

var afterInfiniteLoaded = function afterInfiniteLoaded() {
  $(".loading-image").removeClass("loading-image").addClass("loaded-image");
};

if ($(".pagination-method-loadmore_btn").length > 0) {
  var AjaxMethod = "click";
} else {
  var AjaxMethod = "scroll";
}

if ($(".collection #AjaxinatePagination").length > 0) {
  var endlessScroll = new Ajaxinate({
    container: ".AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    method: AjaxMethod,
    offset: 0,
    callback: afterInfiniteLoaded,
  });
}


// ---------------------------------------------------------------------------
// Custom Functions
// ---------------------------------------------------------------------------

InitCustomFunctions();

function InitCustomFunctions() {

  $(".facet-checkbox input:checkbox").each(function () {
    if ($(this).is(":checked")) {
      $(this).parent(".facet-checkbox").addClass("active");
    }
  });


  // -------------------------------------------------------------------------
  // Filter
  // -------------------------------------------------------------------------

  if ($(".toggleFilter").length > 0) {
    const filter = document.querySelector(".toggleFilter");
    const sidebar = document.querySelector(".facets-vertical");
    const closeDiv = document.querySelector(".close-sidebar");

    filter.addEventListener("click", () => {
      filter.classList.toggle("active");
      sidebar.classList.toggle("open");

      $("body").addClass("overflow-hidden");
      $("body").addClass("filter-clicked");
    });

    closeDiv.addEventListener("click", () => {
      filter.classList.remove("active");
      sidebar.classList.remove("open");

      $("body").removeClass("overflow-hidden");
      $("body").removeClass("filter-clicked");
    });
  }


  // -------------------------------------------------------------------------
  // Product page color variant
  // -------------------------------------------------------------------------

  if ($(".show-grouped__variant").length > 0) {

    $('input:radio[name="Color"]').click(function () {

      const cvariant = $(this).val();

      $(this)
        .closest("fieldset")
        .find(".form__label span")
        .text(cvariant);

      $('input:radio[name="Color"]')
        .next(".swatch-element")
        .removeClass("clicked");

      $(this)
        .next(".swatch-element")
        .addClass("clicked");

      $(".slick-list").addClass("height_fix");

      $(".thumbnail-list__item").each(function () {

        const variant_val = $(this).find("img").attr("alt");

        if (cvariant == variant_val) {
          $(this).addClass("show");
          $(this).removeClass("hidden");
        } else {
          $(this).addClass("hidden");
          $(this).removeClass("show");
        }

      });

    });
  }


  // -------------------------------------------------------------------------
  // Item swatch trigger start
  // -------------------------------------------------------------------------

  $(document).on("click", ".color-values a", function () {

    if ($(this).hasClass("active")) {

      $(this)
        .closest(".variant-option-color")
        .find(".color-values a")
        .removeClass("active");

    } else {

      $(this)
        .closest(".variant-option-color")
        .find(".color-values a")
        .removeClass("active");

      $(this).addClass("active");

    }

  });


  $(document).on("click", ".size-values a", function () {

    if ($(this).hasClass("active")) {

      $(this)
        .closest(".variant-option-size")
        .find(".size-values a")
        .removeClass("active");

    } else {

      $(this)
        .closest(".variant-option-size")
        .find(".size-values a")
        .removeClass("active");

      $(this).addClass("active");

    }

  });


  $(".color-values-plus a").click(function (e) {

    $(this)
      .parents(".variant-option-color")
      .find(".show-on-click")
      .css("display", "flex");

    $(this)
      .parents(".color-values-plus")
      .css("display", "none");

    e.preventDefault();

  });


  $(".swatch span").click(function (e) {

    var featuredMedia = $(this)
      .parents(".card-wrapper")
      .find(".card__inner .motion-reduce")
      .attr("srcset", $(this).data("image"));

    $(this)
      .parents(".card-wrapper")
      .find(".card__inner .motion-reduce")
      .attr("srcset", $(this).data("image"));


    if ($(this).parents(".swatch").hasClass("color")) {

      const variant = $(this).data("id");

      $(this)
        .parents(".product-grid")
        .find(".variant-push")
        .val(variant);

      var swatch_item = $(this).data("variant-item");

      $(this)
        .parents(".product-grid")
        .find(".variant-option-size .size-values")
        .removeClass("active");

      $(this)
        .parents(".product-grid")
        .find(".variant-option-size .swatch")
        .each(function () {

          var swatch_size_vars = $(this)
            .find("span")
            .data("variant-title");

          swatch_size_vars = swatch_size_vars.split("/");

          swatch_size_vars = $.map(
            swatch_size_vars,
            $.trim
          );

          swatch_size_vars = $.map(
            swatch_size_vars,
            function (n) {
              return n.toLowerCase();
            }
          );

          swatch_size_vars = $.map(
            swatch_size_vars,
            function (n) {
              return n.replace(/ /g, "-");
            }
          );

          if ($.inArray(swatch_item, swatch_size_vars) >= 0) {
            $(this)
              .parent(".size-values")
              .toggleClass("active");
          }

        });

    }


    if ($(this).parents(".swatch").hasClass("size")) {

      var variant = $(this).data("id");

      $(this)
        .parents(".product-grid")
        .find(".variant-push")
        .val(variant);

    }

  });


  // -------------------------------------------------------------------------
  // Item swatch trigger end
  // -------------------------------------------------------------------------

  $(".custom-product-grid li").click(function () {

    var classNames =
      "list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop align-1-column align-2-column align-3-column align-4-column align-5-column";

    var getCols = $(this).data("cols");

    var getVal = $(this).data("val");

    var getVal = "align-" + getVal + "-column";

    $(".custom-product-grid li").removeClass("active");

    $(this).addClass("active");

    $("ul#product-grid")
      .removeClass(classNames)
      .addClass(getCols + " " + getVal);

  });


  // -------------------------------------------------------------------------
  // View mode
  // -------------------------------------------------------------------------

  if ($(".filter-buttons").length > 0) {

    const viewExists =
      document.querySelector(".grid-view-button");

    if (viewExists.classList.contains("layout-mode")) {

      const listViewButton =
        document.querySelector(".list-view-button");

      const gridViewButton =
        document.querySelector(".grid-view-button");

      const list =
        document.querySelector("ul.view-mode");

      const gridviewlist =
        document.querySelector(".custom-product-grid");


      listViewButton.onclick = function () {

        listViewButton.classList.add("active");

        gridViewButton.classList.remove("active");

        list.classList.remove("grid-view-filter");

        list.classList.add("list-view-filter");

        gridviewlist.classList.add("hidden");

      };


      gridViewButton.onclick = function () {

        listViewButton.classList.remove("active");

        gridViewButton.classList.add("active");

        list.classList.remove("list-view-filter");

        list.classList.add("grid-view-filter");

        gridviewlist.classList.remove("hidden");

      };

    }

  }


  // -------------------------------------------------------------------------
  // Swiper
  // -------------------------------------------------------------------------

  if ($("#swiper-sidebar-carousel").length > 0) {

    var swiper = new Swiper(
      "#swiper-sidebar-carousel",
      {
        navigation: {
          nextEl: "#swiper-sidebar-next",
          prevEl: "#swiper-sidebar-prev",
        },
      }
    );

  }


  setTimeout(function () {

    $(".loading-image")
      .removeClass("loading-image")
      .addClass("loaded-image");

  }, 2000);


  const radioButtons =
    document.querySelectorAll(
      '.dt-sort__container input[name="sort_by"]'
    );

  const optionSummary =
    document.querySelector(
      ".dt-sort__container .facets__summary-label"
    );

  var selectedRadioButton;

  for (const radioButton of radioButtons) {

    if (radioButton.checked) {

      selectedRadioButton =
        radioButton.getAttribute("data-value");

      optionSummary.innerHTML =
        selectedRadioButton;

    }

  }

}


// ---------------------------------------------------------------------------
// Frequently Bought Together
// ---------------------------------------------------------------------------

$("ul.custom-select").on(
  "click",
  "li:not(.init)",
  function () {

    var selectedVal =
      $(this).data("option-value");

    $(this)
      .parents(".fbt-product__meta")
      .find(".selectVariant option")
      .attr("selected", false);

    $(this)
      .parents(".fbt-product__meta")
      .find(
        ".selectVariant option[value=" +
        selectedVal +
        "]"
      )
      .attr("selected", "selected")
      .trigger("change");

  }
);


$("ul.custom-select").on(
  "click",
  ".init",
  function () {

    $(this)
      .closest("ul.custom-select")
      .children("li:not(.init)")
      .toggle();

  }
);


$("ul.custom-select").on(
  "click",
  "li:not(.init)",
  function () {

    $(this)
      .parent()
      .children("li:not(.init)")
      .removeClass("selected");

    $(this).addClass("selected");

    $(this)
      .parent()
      .children(".init")
      .html($(this).html());

    $(this)
      .parent()
      .children(".init")
      .removeClass("li-unselected");

    $(this)
      .parent()
      .children("li:not(.init)")
      .toggle();

    if (
      $("ul.custom-select li.init")
        .hasClass("li-unselected")
    ) {

      $("#add-frequently-bought")
        .prop("disabled", true);

    } else {

      $("#add-frequently-bought")
        .prop("disabled", false);

    }

  }
);


// ---------------------------------------------------------------------------
// Background loading
// ---------------------------------------------------------------------------

loadedBg();

function loadedBg() {

  window.onload = function () {

    setTimeout(function () {

      $(".loading-image")
        .removeClass("loading-image")
        .addClass("loaded-image");

    }, 3000);

  };

}


// ---------------------------------------------------------------------------
// Stop iframe videos
// ---------------------------------------------------------------------------

jQuery(function () {

  jQuery().on("click", function () {

    jQuery("iframe")
      .contents()
      .find("video")
      .each(function () {

        this.currentTime = 0;
        this.pause();

      });

  });

});


// ---------------------------------------------------------------------------
// Header Drawer Close
// ---------------------------------------------------------------------------

document
  .querySelector(".header-drawer__close")
  .addEventListener(
    "click",
    closeDrawerMenu
  );

function closeDrawerMenu() {

  document
    .querySelector("body")
    .classList
    .remove("overflow-hidden-tablet");

}


// ---------------------------------------------------------------------------
// Sticky Search
// ---------------------------------------------------------------------------

$("#dT_TopStickySearchBtn").click(function (ev) {

  ev.preventDefault();

  $("#dT_top-sticky")
    .addClass("search-show");

  $("#dT_top-sticky .search-modal")
    .css("opacity", "1");

  $("body")
    .addClass("search-overlay-open");

});


$(".dT_TopStickySearchCloseBtn").click(function (ev) {

  ev.preventDefault();

  $("#dT_top-sticky")
    .removeClass("search-show");

  $("#dT_top-sticky .search-modal")
    .css("opacity", "0");

  $("body")
    .removeClass("search-overlay-open");

});


setTimeout(function () {

  $("#AccessibleNav .sub-menu-block")
    .show();

}, 1000);


// ---------------------------------------------------------------------------
// Main Content
// ---------------------------------------------------------------------------

$(document).ready(function () {

  setTimeout(function () {

    document
      .getElementById("MainContent")
      .classList
      .remove("placeholder-shadow-blocks");

  }, 2000);

});


// ---------------------------------------------------------------------------
// Product Accordion
// ---------------------------------------------------------------------------

$(function () {

  $(".acc__title").click(function (j) {

    var dropDown =
      $(this).closest(".dt-sc-tabs-content");

    $(this)
      .closest("dt-sc-tabs-content")
      .not(dropDown)
      .slideUp();

    if ($(this).hasClass("active")) {

      $(this).removeClass("active");

    } else {

      $(this)
        .closest("dt-sc-tabs-content.active")
        .removeClass("active");

      $(this).addClass("active");

    }

    dropDown
      .stop(false, true)
      .slideToggle();

    j.preventDefault();

  });

});


// ---------------------------------------------------------------------------
// Tabs
// ---------------------------------------------------------------------------

$(document).ready(function () {

  $(".tablinks").click(function () {

    $(".dt-sc-tabs-content")
      .removeClass("tab-active-content");

    $(".dt-sc-tabs-content[data-id='" +
      $(this).attr("data-id") +
      "']")
      .addClass("tab-active-content");

    $(".tablinks")
      .removeClass("active-tab");

    $(this)
      .addClass("active-tab");

  });

});


// ---------------------------------------------------------------------------
// Hotspot
// ---------------------------------------------------------------------------

$(document).ready(function () {
  hotSpot();
});

$(window).on("resize", function () {
  hotSpot();
});

function hotSpot() {

  if ($(window).width() > 250) {

    if ($(".tool-tip-style-1").length > 0) {

      jQuery(function ($) {

        $(".dt-sc-hotspot-item").each(function () {

          var pop =
            $(this).find(".dt-sc-hotspot-popup");

          pop.click(function (e) {
            e.stopPropagation();
          });


          $(this)
            .find("a.dt-sc-hotspot-marker")
            .click(function (e) {

              e.preventDefault();
              e.stopPropagation();

              $(this)
                .parent()
                .parent()
                .addClass(
                  "this-hotspot-in-active"
                );


              if ($(this).hasClass("clicked")) {

                $(this).removeClass("clicked");

                $(".this-hotspot-in-active")
                  .find(
                    "a.dt-sc-hotspot-marker"
                  )
                  .css({
                    opacity: "0",
                    "pointer-events": "none",
                  });

                $(this).css({
                  opacity: "1",
                  "pointer-events": "none",
                });

                $(".dt-sc-hotspot-item")
                  .removeClass("open");

                $("a.dt-sc-hotspot-marker")
                  .css({
                    opacity: "1",
                    "pointer-events": "none",
                  });

              } else {

                $(this).addClass("clicked");

                $(".this-hotspot-in-active")
                  .find(
                    "a.dt-sc-hotspot-marker"
                  )
                  .css({
                    opacity: "0",
                    "pointer-events": "none",
                  });

                $(this).css({
                  opacity: "1",
                  "pointer-events": "auto",
                });

                $(this)
                  .parent()
                  .addClass("open");

                $(this)
                  .next(".dt-sc-hotspot-popup")
                  .toggleClass(
                    "dt-sc-popup-open"
                  );

                $(this)
                  .parent()
                  .siblings()
                  .children(".dt-sc-hotspot-popup")
                  .removeClass(
                    "dt-sc-popup-open"
                  );

              }

            });


          $(document).click(function () {

            $(".dt-sc-hotspot-wrapper")
              .removeClass(
                "this-hotspot-in-active"
              );

            pop.removeClass(
              "dt-sc-popup-open"
            );

            $(".dt-sc-hotspot-item")
              .removeClass("open");

            $("a.dt-sc-hotspot-marker")
              .removeClass("clicked");

            $("a.dt-sc-hotspot-marker")
              .css({
                opacity: "1",
                "pointer-events": "auto",
              });

          });

        });

      });

    }


    if ($(".tool-tip-style-3").length > 0) {

      jQuery(function ($) {

        $(".dt-sc-hotspot-item").each(function () {

          var pop =
            $(this).find(".dt-sc-hotspot-popup");

          pop.hover(function (e) {
            e.stopPropagation();
          });


          $(this)
            .find("a.dt-sc-hotspot-marker")
            .hover(function (e) {

              e.preventDefault();
              e.stopPropagation();

              $(this)
                .parent()
                .parent()
                .addClass(
                  "this-hotspot-in-active"
                );


              if ($(this).hasClass("clicked")) {

                $(this).removeClass("clicked");

                $(".this-hotspot-in-active")
                  .find(
                    "a.dt-sc-hotspot-marker"
                  )
                  .css({
                    opacity: "0",
                    "pointer-events": "none",
                  });

                $(this).css({
                  opacity: "1",
                  "pointer-events": "auto",
                });

                $(".dt-sc-hotspot-item")
                  .removeClass("open");

                $("a.dt-sc-hotspot-marker")
                  .css({
                    opacity: "1",
                    "pointer-events": "auto",
                  });

              } else {

                $(this).addClass("clicked");

                $(".this-hotspot-in-active")
                  .find(
                    "a.dt-sc-hotspot-marker"
                  )
                  .css({
                    opacity: "0",
                    "pointer-events": "none",
                  });

                $(this).css({
                  opacity: "1",
                  "pointer-events": "auto",
                });

                $(this)
                  .parent()
                  .addClass("open");

                $(this)
                  .next(".dt-sc-hotspot-popup")
                  .toggleClass(
                    "dt-sc-popup-open"
                  );

                $(this)
                  .parent()
                  .siblings()
                  .children(".dt-sc-hotspot-popup")
                  .removeClass(
                    "dt-sc-popup-open"
                  );

              }

            });


          $(this)
            .find("a.dt-sc-hotspot-marker")
            .mouseout(function () {

              $(".dt-sc-hotspot-wrapper")
                .removeClass(
                  "this-hotspot-in-active"
                );

              pop.removeClass(
                "dt-sc-popup-open"
              );

              $(".dt-sc-hotspot-item")
                .removeClass("open");

              $("a.dt-sc-hotspot-marker")
                .removeClass("clicked");

              $("a.dt-sc-hotspot-marker")
                .css({
                  opacity: "1",
                  "pointer-events": "auto",
                });

            });


          $(document).click(function () {

            $(".dt-sc-hotspot-wrapper")
              .removeClass(
                "this-hotspot-in-active"
              );

            pop.removeClass(
              "dt-sc-popup-open"
            );

            $(".dt-sc-hotspot-item")
              .removeClass("open");

            $("a.dt-sc-hotspot-marker")
              .removeClass("clicked");

            $("a.dt-sc-hotspot-marker")
              .css({
                opacity: "1",
                "pointer-events": "auto",
              });

          });

        });

      });

    }

  }


  if ($(window).width() < 251) {

    $(".dt-sc-hotspot-popup")
      .addClass("mfp-hide");

    $(".dt-sc-hotspot-marker").each(function () {

      $(this).magnificPopup({
        type: "inline",
        closeOnBgClick: true,
        closeBtnInside: false,
        showCloseBtn: true,
      });

    });

  }

}


// ---------------------------------------------------------------------------
// Product Deal Timer
// ---------------------------------------------------------------------------

function makeTimer() {

  $(".product-deal-count").each(function () {

    var endTime =
      new Date(
        $(this).attr("data-end-time")
      );

    endTime =
      Date.parse(endTime) / 1000;

    var now = new Date();

    now =
      Date.parse(now) / 1000;

    var timeLeft =
      endTime - now;


    if (timeLeft > 0) {

      var days =
        Math.floor(timeLeft / 86400);

      var hours =
        Math.floor(
          (timeLeft -
            days * 86400) /
          3600
        );

      var minutes =
        Math.floor(
          (timeLeft -
            days * 86400 -
            hours * 3600) /
          60
        );

      var seconds =
        Math.floor(
          timeLeft -
          days * 86400 -
          hours * 3600 -
          minutes * 60
        );


      if (hours < "10") {
        hours = "0" + hours;
      }

      if (minutes < "10") {
        minutes = "0" + minutes;
      }

      if (seconds < "10") {
        seconds = "0" + seconds;
      }


      $(this)
        .find(".days")
        .html(
          days +
          "<span>" +
          window.deals.days +
          "</span>"
        );

      $(this)
        .find(".hours")
        .html(
          hours +
          "<span>" +
          window.deals.hours +
          "</span>"
        );

      $(this)
        .find(".minutes")
        .html(
          minutes +
          "<span>" +
          window.deals.minutes +
          "</span>"
        );

      $(this)
        .find(".seconds")
        .html(
          seconds +
          "<span>" +
          window.deals.seconds +
          "</span>"
        );

    } else {

      $(this)
        .find(".deal-lable")
        .hide();

      $(this)
        .find(".deal-clock")
        .hide();

    }

  });

}

setInterval(function () {
  makeTimer();
}, 1000);


// ---------------------------------------------------------------------------
// iOS TOUCH → CLICK FALLBACK
// ---------------------------------------------------------------------------
// Fixes iPhone Safari where touch/pointer events happen but the normal
// jQuery click event is not fired for product-page interactive elements.

(function () {

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (
      navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints > 1
    );

  if (!isIOS) return;


  const selectors = [ 
 
    // Product page 
    ".acc__title", 
    ".tablinks", 
    ".add-compare", 
    ".quantity__button",
    ".tech-details-link",
    ".dt-nav-btn.dt-nav-prev",
    ".dt-nav-btn.dt-nav-next",
    ".ai-you-may-like-nav-btn.ai-you-may-like-prev-",
    ".ai-you-may-like-nav-btn.ai-you-may-like-next-",
    ".html-sections-product a[href*='cancellations-refund-policy']",
    '[class*="read-more-btn"]',
    ".list-social__link",
 
    // Product variants 
    ".color-values a", 
    ".size-values a", 
    ".color-values-plus a", 
    ".swatch span", 
 
    // Product / collection controls 
    ".custom-product-grid li", 
    ".toggleFilter", 
    ".close-sidebar", 
 
    // Header / mobile menu 
    ".header-drawer__close", 
    ".menu-drawer-button", 
    ".header__icon--menu", 
    "summary.header__icon", 
    ".menu-drawer summary", 

    // Trustoo / CWILL Reviews
    ".tt-write-reviews",
    ".star-item",
    ".tt-image-uploader",
    ".upload-input",
    ".tt-delete_image",
    "#tt-protection-checkbox",
    ".window-close",

    // Trustoo / CWILL form fields
    'input[input-type="author"]',
    'input[input-type="author_email"]',

    // Footer
    ".footer-block__heading",
    ".footer-block__details-content a",
    ".whatsapp-floating-button",
    ".dt-sc-to-top",
    '[class*="ai-you-may-like-card-link"]',
  ];


  let touchTarget = null;
  let touchHandled = false;


  // ---------------------------------------------------------
  // TOUCH START
  // ---------------------------------------------------------

  document.addEventListener(
    "touchstart",
    function (event) {

      const trustooField = event.target.closest(
      'input[input-type="author"], input[input-type="author_email"]'
      );

      if (trustooField) {
      trustooField.focus();
      }
      const newsletterField = event.target.closest(
      "#NewsletterForm--footer"
      );

      if (newsletterField) {
      newsletterField.focus();
      }

      const target =
        event.target.closest(
          selectors.join(",")
        );

      if (!target) {

        touchTarget = null;
        touchHandled = false;

        return;
      }

      touchTarget = target;
      touchHandled = false;

    },
    {
      passive: true
    }
  );


  // ---------------------------------------------------------
  // TOUCH END
  // ---------------------------------------------------------

  document.addEventListener(
  "touchend",
  function (event) {

    // Footer social links - iOS
    const socialLink = event.target.closest(
    ".list-social__link"
    );

    if (socialLink) {
    event.preventDefault();

    window.location.href = socialLink.href;

    touchTarget = null;
    touchHandled = false;

   return;
    }

    // Read more - iOS
    const readMoreButton = event.target.closest(
    '[class*="read-more-btn"]'
    );

    if (readMoreButton) {
    event.preventDefault();

    readMoreButton.click();

    touchTarget = null;
    touchHandled = false;

   return;
    }

    // Return & Refund Policy - iOS
    const refundPolicyLink = event.target.closest(
    ".html-sections-product a[href*='cancellations-refund-policy']"
    );

    if (refundPolicyLink) {
    event.preventDefault();

    window.location.href = refundPolicyLink.href;

    touchTarget = null;
    touchHandled = false;

    return;
    }

    // You May Also Like product links - iOS
    const youMayLikeProduct = event.target.closest(
    '[class*="ai-you-may-like-card-link"]'
    );

    if (youMayLikeProduct) {
    event.preventDefault();

    window.location.href = youMayLikeProduct.href;

    touchTarget = null;
    touchHandled = false;

    return;
    }

    // You May Also Like Previous / Next - iOS
    const youMayLikeNav = event.target.closest(
    '[class*="ai-you-may-like-nav-btn"][aria-label="Previous"], ' +
    '[class*="ai-you-may-like-nav-btn"][aria-label="Next"]'
    );

    if (youMayLikeNav) {
    event.preventDefault();

    youMayLikeNav.click();

    touchTarget = null;
    touchHandled = false;

    return;
    }

    // Product image Previous / Next - iOS
    const imageNavButton = event.target.closest(
    ".dt-nav-btn.dt-nav-prev, .dt-nav-btn.dt-nav-next"
    );

    if (imageNavButton) {
    event.preventDefault();

    imageNavButton.click();

    touchTarget = null;
    touchHandled = false;

    return;
    }

    // Technical details - iOS
    const techDetailsLink = event.target.closest(
    ".tech-details-link"
    );

    if (techDetailsLink) {
    event.preventDefault();

    const targetId = techDetailsLink.getAttribute("data-scroll-to");
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
    }

    touchTarget = null;
    touchHandled = false;

    return;
    }

    // Product quantity + / - - iOS
    const quantityButton = event.target.closest(
    ".quantity__button"
    );

    if (quantityButton) {
    event.preventDefault();

    quantityButton.click();

    touchTarget = null;
   touchHandled = false;

    return;
    }

    // Back to top - iOS
    const backToTop = event.target.closest(".dt-sc-to-top");

    if (backToTop) {
    event.preventDefault();

    backToTop.click();

    touchTarget = null;
    touchHandled = false;

    return;
    }

    // WhatsApp floating button - iOS
    const whatsappButton = event.target.closest(
    ".whatsapp-floating-button"
    );

    if (whatsappButton) {
    event.preventDefault();

    whatsappButton.click();

    touchTarget = null;
    touchHandled = false;

   return;
    }

    // Footer links - iOS direct navigation
    const footerLink = event.target.closest(
    ".footer-block__details-content a"
    );

    if (footerLink) {
    event.preventDefault();

    window.location.href = footerLink.href;

    touchTarget = null;
    touchHandled = false;

    return;
    }

    // Newsletter Subscribe - iOS
    const subscribeButton = event.target.closest("#Subscribe");

    if (subscribeButton) {
    event.preventDefault();

    const newsletterForm = subscribeButton.closest("form");

    if (newsletterForm) {
    newsletterForm.requestSubmit();
    }

    touchTarget = null;
    touchHandled = false;

    return;
    }

    // Trustoo / CWILL review popup close
    const closeReviewPopup =
    touchTarget && touchTarget.closest(".window-close");

    if (closeReviewPopup) {
    event.preventDefault();

    HTMLElement.prototype.click.call(closeReviewPopup);

    touchTarget = null;
    touchHandled = false;

    return;
    }

    // Trustoo / CWILL protection checkbox
    const protectionCheckbox = event.target.closest(
    "#tt-protection-checkbox"
    );

    if (protectionCheckbox) {
    event.preventDefault();

    protectionCheckbox.checked = !protectionCheckbox.checked;

    protectionCheckbox.dispatchEvent(
    new Event("change", {
      bubbles: true
    })
    );

    touchTarget = null;
    touchHandled = false;

    return;
    }
    

   // Trustoo / CWILL photo delete
    const deletePhoto = event.target.closest(".tt-delete_image");

    if (deletePhoto) {
    event.preventDefault();

    deletePhoto.click();

    touchTarget = null;
    touchHandled = false;

    return;
  }

    // Trustoo / CWILL photo upload
    const uploadArea = event.target.closest(
    ".tt-image-uploader, .upload-input"
    );

    if (uploadArea) {
    event.preventDefault();

    const fileInput =
    uploadArea.matches(".upload-input")
      ? uploadArea
      : uploadArea.querySelector(".upload-input");

  if (fileInput) {
    fileInput.click();
  }

  touchTarget = null;
  touchHandled = false;

  return;
}

    // Trustoo / CWILL Name & Email fields
    const trustooField = event.target.closest(
      'input[input-type="author"], input[input-type="author_email"]'
    );

    if (trustooField) {
      event.preventDefault();

      setTimeout(function () {
        trustooField.focus();
      }, 10);

      return;
    }

    if (
      event.target.closest(
        "input, textarea, select, option, [contenteditable='true']"
      )
    ) {
      return;
    }

    if (!touchTarget || touchHandled) return;

    const target = touchTarget;


    // Make sure finger is still on the same element
    if (
      !target.contains(event.target) &&
      target !== event.target
    ) {

      touchTarget = null;
      touchHandled = false;

      return;
    }


    touchHandled = true;


    // Prevent Safari's default delayed click
    event.preventDefault();


    // Trigger the existing jQuery click handler
    setTimeout(function () {

      try {

        $(target).trigger("click");

      } catch (error) {

        console.error(
          "iOS click fallback error:",
          error
        );

      }

    }, 10);


    // Reset touch state
    setTimeout(function () {

      touchTarget = null;
      touchHandled = false;

    }, 500);

  },
  {
    passive: false
  }
);

})();